﻿import { MenubarItem } from './menubarItem';
import { IMenuItem, IMenuItemParent, MenuItemParentType } from './menuItemBase';
import { PopupMenu } from './popupMenu';

export class Navigation implements IMenuItemParent {
    private _domNode: HTMLElement | null = null;

    private menubarItems: IMenuItem[] = [];
    private firstItem: IMenuItem | null = null;
    private lastItem: IMenuItem | null = null;

    public hasFocus: boolean = false;
    public hasHover: boolean = false;
    public type: MenuItemParentType = "Navigation";

    /**
     * Traverse the element children of menubarNode: configure each with menuitem role behavior and store reference in menuitems array.
     */
    private configureNodes() {
        if (!this._domNode) {
            return
        }

        let currentElement = this._domNode.firstElementChild;

        while (currentElement) {
            const menuElement: HTMLElement = <HTMLElement>(
                currentElement.firstElementChild
            );

            const menubarItem: MenubarItem = new MenubarItem(menuElement, this);
            this.menubarItems.push(menubarItem);

            currentElement = currentElement.nextElementSibling;

        }

        // Use populated menuitems array to initialize firstItem and lastItem.
        const numItems: number = this.menubarItems.length;
        if (numItems > 0) {
            this.firstItem = this.menubarItems[0];
            this.lastItem = this.menubarItems[numItems - 1];
        }
        if (this.firstItem) {
            this.firstItem.domNode.tabIndex = 0;
        }

    }

    public SetFocusToItem(item: IMenuItem) {
        let flag: boolean = false;
        for (let i: number = 0; i < this.menubarItems.length; i++) {
            let mbi: IMenuItem = this.menubarItems[i];
            mbi.domNode.tabIndex = -1;
            if (mbi.domNode.tabIndex == 0) {
                flag = mbi.domNode.getAttribute("aria-expanded") === "true";
            }

            mbi.domNode.tabIndex = -1;
            if (mbi.menu) {
                setTimeout(mbi.menu.Close.bind(false), 400);
            }
        }

        item.domNode.focus();
        item.domNode.tabIndex = 0;
        if (flag && item.menu) {
            (item.menu as unknown as PopupMenu).Open()
        }
    }

    public SetFocusToFirstItem() {
        if (this.firstItem !== null) {
            this.SetFocusToItem(this.firstItem);
        }
    }

    public SetFocusToLastItem() {
        if (this.lastItem !== null) {
            this.SetFocusToItem(this.lastItem);
        }
    }

    public SetFocusToPreviousItem(currentItem: IMenuItem) {
        let index: number;
        let newItem: IMenuItem | null;

        if (currentItem === this.firstItem) {
            newItem = this.lastItem;
        } else {
            index = this.menubarItems.indexOf(currentItem);
            newItem = this.menubarItems[index - 1];
        }
        if (newItem !== null) {
            this.SetFocusToItem(newItem);
        }
    }

    public SetFocusToNextItem(currentItem: MenubarItem) {
        let index: number;
        let newItem: IMenuItem | null;
        if (currentItem === this.lastItem) {
            newItem = this.firstItem;
        } else {
            index = this.menubarItems.indexOf(currentItem);
            newItem = this.menubarItems[index + 1];
        }
        if (newItem !== null) {
            this.SetFocusToItem(newItem);
        }
    }

    constructor(rootId: string = "nav-bar") {
        //Get root node
        const rootNode = document.getElementById(rootId);

        if (rootNode) {
            this._domNode = rootNode;
            this.configureNodes();
        }
    }

    public Close = (force: boolean) => undefined;
}
